module.exports = __webpack_public_path__ + "static/media/face-sad-filled.94cd534f.svg";